module.exports = __webpack_public_path__ + "img/24_37.a7839fbe.png";